import {
  Component,
  OnInit,
  Input,
  ViewEncapsulation,
  HostListener,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
  ChangeDetectionStrategy
} from '@angular/core';

import { findIndex } from 'lodash';
import { AuthService } from '../../../auth/auth.service';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-work-shifts-table',
  templateUrl: './work-shifts-table.component.html',
  styleUrls: ['./work-shifts-table.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class WorkShiftsTableComponent implements OnInit {
  fixedHeader = false;

  @Input() filter;
  @Input() templateFilter;
  @Input() templateFilterData;
  @Input() calendar;
  @Input() users;
  @Input() isActiveTemplateFilter;
  @Input() isActiveTemplateFilterPreviewMode;

  @ViewChild('weeksHeaderWrapper')
  weeksHeaderElementWrapper: ElementRef;
  @ViewChild('weeksHeader') weeksHeaderElement: ElementRef;

  @HostListener('window:scroll.out-zone', []) // notice out-zone
  onWindowScroll() {
    let weeksHeaderWrapperPosition = this.weeksHeaderElementWrapper.nativeElement.offsetTop;
    let worksShiftsParentContainer = document.getElementById('work-shifts-parent-container').offsetTop;
    if (window.pageYOffset >= weeksHeaderWrapperPosition + worksShiftsParentContainer) {
      if (!this.fixedHeader) {
        const fixedBlockWidth = this.weeksHeaderElement.nativeElement.offsetWidth;

        this.fixedHeader = true;
        this.weeksHeaderElement.nativeElement.style.width = fixedBlockWidth + 'px';
        this.weeksHeaderElement.nativeElement.classList.add('weeks-header--fixed');
      }
    } else {
      if (this.fixedHeader) {
        this.fixedHeader = false;
        this.weeksHeaderElement.nativeElement.classList.remove('weeks-header--fixed');
      }
    }
  }

  constructor(
    private cd: ChangeDetectorRef,
    private authService: AuthService
  ) {}

  ngOnInit() {}

  get isGRS() {
    return this.authService.isGRSUser();
  }

  onAddSelectedUser(user) {
    let isRelacationUser = false;

    // Нельзя добавлять в режим шаблонного заполнения прикомандированного монтажника.
    user.working_shift.forEach((workShift) => {
      if (workShift.schedule && workShift.schedule.sector && workShift.schedule.sector.sector_id === this.filter.plotSelected.sector_id) {
        isRelacationUser = true;
      }
    });

    if (isRelacationUser) {
      alert('Внимание! Редактирование ячеек у прикомандированного работника в режиме "Заполнение смен по шаблону"' + ' не доступно.');
    } else {
      user.isSelected = true;
      this.templateFilter.selectedUsers.push(user);
    }
  }

  onRemoveSelectedUser(user) {
    user.isSelected = false;
    let index = findIndex(this.templateFilter.selectedUsers, {
      u_id: user.u_id,
    });

    if (index > -1) {
      this.templateFilter.selectedUsers.splice(index, 1);
    }
  }
}
